import { Vector } from 'matter';
import Phaser from 'phaser';
import BarGui from './GUI/BarGUI';
import MathHelpers from './Math/MathHelpers';

export default class Monster {
    private mName: string;
    private mVeclotity: number;
    private mMaxHealthPoints: number;
    private mHealthPoints: number;
    private mMinGoldDrop?: number = 0;
    private mMaxGoldDrop?: number = 0;
    private mExperienceDrop: number = 0;
    private mIsDestroyed: boolean;
    DamageDealing: number;
    private mSprite: Phaser.Types.Physics.Arcade.SpriteWithStaticBody;
    private mHealthBar: BarGui;
    public ShowHealthBar: boolean = true;

    constructor(sprite: Phaser.Types.Physics.Arcade.SpriteWithStaticBody, scene, config: MonsterConfig, shouldSetHealthBar: boolean = true) {
        this.mSprite = sprite;
        this.mName = config.Name;
        this.mVeclotity = config.Velocity;
        this.mMaxHealthPoints = config.MaxHP;
        this.mHealthPoints = config.MaxHP;
        this.mMinGoldDrop = config.MinimumGoldDrop;
        this.mMaxGoldDrop = config.MaximumGoldDrop;
        this.mExperienceDrop = config.ExperienceDrop;
        this.mIsDestroyed = false;
        if (shouldSetHealthBar) {
            this.mHealthBar = new BarGui(scene, sprite.x, sprite.y, config.MaxHP);
            this.mHealthBar.X = sprite.body.x;
            this.mHealthBar.Y = sprite.body.y;
        }
        //TODO: To configuration?
        this.DamageDealing = 20;
    }

    Update(time: number): void {
        if (this.mIsDestroyed) {
            return;
        }
        this.mSprite.x -= this.mVeclotity * time;
        this.mSprite.body.x -= this.mVeclotity * time;

        this.mHealthBar.X = this.mSprite.x - 40;
        this.mHealthBar.Y = this.mSprite.y - this.mSprite.height / 2 - 20;
        if (!this.ShowHealthBar) {
            this.mHealthBar.Clear();
        }
        this.mHealthBar.Draw();
    }

    Damage(damage: number): void {
        this.mHealthPoints -= damage;
        this.mHealthBar.Decrease(damage);
    }

    IsDead(): boolean {
        return this.mHealthPoints <= 0;
    }

    Name(): string {
        return this.mName;
    }

    Sprite(): Phaser.Types.Physics.Arcade.SpriteWithStaticBody {
        return this.mSprite;
    }

    Destroy() {
        this.mSprite.destroy();
        this.mIsDestroyed = true;
        this.mHealthBar.Destroy();
    }

    SetPosition(vector: Phaser.Math.Vector2) {
        this.mSprite.x = vector.x;
        this.mSprite.y = vector.y;
        this.mSprite.refreshBody();
    }
    GetX() {
        return this.mSprite.x;
    }
    GetY() {
        return this.mSprite.y;
    }

    GetMoneyDropped(): number {
        return MathHelpers.RandomInteger(this.mMinGoldDrop, this.mMaxGoldDrop);
    }

    GetExpDropped(): number {
        return this.mExperienceDrop;
    }
}


export type MobFileConfig = {
    Type: string,
    FileName: string,
    FrameStart: number,
    FrameEnd: number,
    Columns: number,
    Rows: number,
    FrameWidth?: number,
    FrameHeight?: number
};

export type MonsterConfig = {
    Name: string,
    Velocity: number,
    MaxHP: number,
    ExperienceDrop: number,
    Damage:number,
    MinimumGoldDrop?: number,
    MaximumGoldDrop?: number,
    Scale?: number,
    File?: MobFileConfig
};